var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details-container"},[_c('div',{staticClass:"details-header"},[_vm._t("header",function(){return [_c('h3',[_vm._v(_vm._s(_vm.title))])]})],2),_c('div',{staticClass:"details"},[_vm._t("body"),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }